import { Route, Router } from "@angular/router";

import { DsV3Plan, notExternalOrParticipatingEntity } from "../../../core/guards";
import { activityTypeEditAccessGuard, activityTypeViewAccessGuard } from "./activities-utils";

export const ACTIVITIES_DS_V3_ROUTES: Route[] = [
  {
    path: "activity",
    canActivate: [DsV3Plan()],
    data: {
      breadcrumb: "breadcrumbs.activity.list",
    },
    children: [
      {
        path: "",
        loadComponent: () => import("../../../shared/components").then((e) => e.SubmenuComponent),
        canActivate: [notExternalOrParticipatingEntity],
        data: {
          onCycleChange: (router: Router) => router.navigateByUrl("console"),
        },
      },
      {
        path: ":activityType",
        children: [
          {
            path: "",
            loadComponent: () => import("./activities-list/activities-list").then((e) => e.ActivitiesListComponent),
            canActivate: [notExternalOrParticipatingEntity, activityTypeViewAccessGuard],
            data: {
              title: "ds_v3.activities.title",
              breadcrumb: {
                alias: "activitiesList",
              },
            },
          },
          {
            path: "edit/:activityId",
            loadComponent: () =>
              import("./activities-editor/activities-editor").then((e) => e.ActivitiesEditorComponent),
            canActivate: [notExternalOrParticipatingEntity, activityTypeEditAccessGuard],
            data: {
              title: "ds_v3.activities.title",
              breadcrumb: {
                alias: "activitiesEditor",
              },
            },
          },
          {
            path: ":activityId",
            loadComponent: () => import("./activities-view/activities-view").then((e) => e.ActivitiesViewComponent),
            canActivate: [activityTypeViewAccessGuard],
            data: {
              title: "ds_v3.activities.title",
              breadcrumb: {
                alias: "activitiesView",
              },
            },
          },
        ],
      },
    ],
  },
];
